<template>
  <div class="federated-search-facet-filter">
    <div class="federated-search-facet-filter__filters-group-title">
      <h3>
        {{ facet.name }}
      </h3>
      <button
        :aria-label="`${collapsed ? 'Show' : 'Hide'} ${facet.name} Filters`"
        :aria-expanded="collapsed ? 'false' : 'true'"
        @click="collapsed = !collapsed"
      >
        <svg aria-hidden="true">
          <use
            :xlink:href="
              `/app/themes/ahc/src/assets/images/icons.svg#${
                collapsed ? 'plus' : 'minus'
              }`
            "
          />
        </svg>
      </button>
    </div>

    <fieldset role="group" :aria-labelledby="`group-label-${facet.name}`">
      <legend :id="`group-label-${facet.name}`">
        {{ facet.displayName }}
      </legend>
      <div
        :aria-hidden="collapsed ? 'true' : 'false'"
        v-for="(option, index) in Object.keys(facet.options).splice(
          0,
          this.displayCount
        )"
        v-bind:key="index"
        class="filter"
      >
        <div v-if="!collapsed" class="filter__option">
          <input
            :ref="refName(index)"
            type="checkbox"
            :id="
              `option-${encodeURIComponent(facet.name)}-${encodeURIComponent(
                option
              )}`
            "
            v-model="localSelectedFilters"
            @change="updateSelectedFilters"
            class="custom-control-input"
            :value="`${facet.name}:${option}`"
          />
          <label
            :for="
              `option-${encodeURIComponent(facet.name)}-${encodeURIComponent(
                option
              )}`
            "
            class="custom-control-label"
          >
            {{ option }}
          </label>
        </div>
        <div v-if="!collapsed" class="filter__count">
          {{ facet.options[option] }}
        </div>
      </div>
    </fieldset>
    <button
      v-if="
        this.displayCount < Object.keys(facet.options).length &&
          this.displayCount < 50 &&
          !collapsed
      "
      class="federated-search-facet-filter__filters-group-show-more"
      type="button"
      @click="increaseDisplayCount"
    >
      <span class="federated-search-facet-filter__filters-group-show-more-text">Show more values</span>
      <span aria-hidden="true" class="federated-search-facet-filter__filters-group-show-more-plus">&nbsp;+</span>
    </button>
  </div>
</template>

<script lang="js">

export default {
  name: 'ahc-federated-search-facet-filter',
  components: {
  },
  methods: {
    increaseDisplayCount() {
      const nextFocusRef = `itemRef${this.displayCount}`
      this.displayCount = this.displayCount + 10;
      this.$forceUpdate();
      this.$nextTick(() => {
        this.$refs[nextFocusRef][0].focus();
      });
    },
    updateSelectedFilters() {
      this.$emit('update:selectedFilters', this.localSelectedFilters);
      this.search({ option: this.facet.name, page: 0 });
    },
    refName(index) {
      const name = `itemRef${index}`;
      if (!this.refs[name]) {
        this.$set(this.refs, name, this.$refs[name]);
      }
      return name;
    },
  },
  props: {
    facet: {
      type: Object,
      required: true
    },
    selectedFilters: {
      type: Array,
      required: true
    },
    defaultDisplayCount : {
      type: Number,
      required: false,
    },
    search: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      collapsed: false,
      localSelectedFilters: [],
      displayCount: 0,
      refs: {}
    }
  },
  mounted() {
    this.localSelectedFilters = this.selectedFilters;
    this.displayCount = this.facet.displayCount;
    this.collapsed = this.facet.collapsedByDefault;
  },
  watch: {
    facet(newVal) {
      this.facet = newVal;
      this.displayCount = newVal.displayCount;
      this.localSelectedFilters = this.selectedFilters;
    }
  }
}
</script>

<style lang="scss">
@import "federated-search-facet-filter";
</style>
